import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  RoutingGroup,
  useRoutingGroupsTableContext,
} from '../../../../RoutingGroupsTableContext'
import { useCreateCasRoutingGroupMutation } from 'schema'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<RoutingGroup> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useRoutingGroupsTableContext()
  const [createRoutingGroup] = useCreateCasRoutingGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createCASRoutingGroup: {
        routingGroup: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Routing Group',
    permission: Permission.CreateCASRoutingGroup,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({ name, users, description }: CreateEditFormItemsValues) => {
        await createRoutingGroup({
          variables: {
            createCASRoutingGroupInput: {
              name,
              projectId,
              description,
              userIds: users?.map(({ value }) => value.toString()),
            },
          },
        })
        await refetch()
      },
    },
  }
}
